import { MINERVA_API_URL, VIDEO_LAMBDA_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

export function fetchMyVideoLectureList({ dispatch }, params) {
  return http.get(`${MINERVA_API_URL}/my-video-lectures`, { params })
    .then(res => (res.data))
    .then(videoLectures => (
      dispatch('setVideoLecturesInStore', videoLectures)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching video lectures:', err);
      return Promise.reject(err);
    });
}

export function fetchVideoLecture({ dispatch }, lectureId) {
  return http.get(`${MINERVA_API_URL}/video-lectures/${lectureId}`)
    .then(res => (res.data))
    .then(videoLecture => (
      dispatch('setVideoLecturesInStore', [videoLecture])
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while fetching video lecture by ID:', err);
      return Promise.reject(err);
    });
}

export function createNewVideoLecture({ dispatch }, params) {
  return http.post(`${MINERVA_API_URL}/video-lectures`, params)
    .then(res => (res.data))
    .then(videoLecture => (
      dispatch('fetchVideoLecture', videoLecture.id)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while creating a new video lecture:', err);
      return Promise.reject(err);
    });
}

export function updateVideoLecture({ dispatch }, params) {
  return http.patch(`${MINERVA_API_URL}/video-lectures/${params.id}`, params)
    .then(res => (res.data))
    .then(() => (
      dispatch('fetchVideoLecture', params.id)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while updating a video lecture:', err);
      return Promise.reject(err);
    });
}

export function removeVideoLecture({ dispatch }, lectureId) {
  return http.delete(`${MINERVA_API_URL}/video-lectures/${lectureId}`)
    .then(res => (res.data))
    .then(() => (
      dispatch('removeVideoLectureInStore', lectureId)
    ))
    .catch((err) => {
      // TODO: handle error
      console.error('err while removing a video lecture:', err);
      return Promise.reject(err);
    });
}

export function getVideoLectureUploadUrl() {
  return http.get(VIDEO_LAMBDA_URL)
    .then(res => (res.data))
    .catch((err) => {
      // TODO: handle error
      console.error('err while getting video lecture upload url:', err);
      return Promise.reject(err);
    });
}

export function uploadVideoLecture(_, { uploadLink, videoFile }) {
  const formData = new FormData();
  formData.append('file_data', videoFile);

  return http.post(uploadLink, formData, {
    transformRequest: [(data, headers) => {
      /* eslint-disable no-param-reassign */
      delete headers.common.Authorization;
      delete headers.common['Country-Code'];
      /* eslint-enable */
      return data;
    }],
  })
  .catch((err) => {
    // TODO: handle error
    console.error('err while uploading video lecture:', err);
    return Promise.reject(err);
  });
}

export function setVideoLecturesInStore({ commit }, videoLectures) {
  commit(types.SET_VIDEO_LECTURE, videoLectures);

  return Promise.resolve(videoLectures);
}

export function removeVideoLectureInStore({ commit }, lectureId) {
  commit(types.REMOVE_VIDEO_LECTURE, lectureId);

  return Promise.resolve(lectureId);
}

export function setRecentVideoUploadInfoInStore({ commit }, uploadInfo) {
  commit(types.SET_RECENT_UPLOAD_INFO, uploadInfo);

  return Promise.resolve(uploadInfo);
}

export function clearVideoLecturesInStore({ commit }) {
  commit(types.CLEAR_VIDEO_LECTURES);

  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/app/video-lectures/store/actions.js